// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message

import { isCustomObject } from 'customer-data-tracking/utils/isCustomObject';
import { useFetchWANumber } from './useFetchWANumber';
import { useHasScope } from 'crm-activity-creator-data/auth/hooks/useHasScope';
import { CONTACT_TYPE_ID, COMPANY_TYPE_ID, DEAL_TYPE_ID, TICKET_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useMemo } from 'react';
const getWAMissingNumberKey = objectTypeId => {
  const objectTypeKeys = {
    [CONTACT_TYPE_ID]: true,
    [COMPANY_TYPE_ID]: 'createActivityButtons.tooltip.whatsAppWithNoPhoneNumber.company',
    [DEAL_TYPE_ID]: 'createActivityButtons.tooltip.whatsAppWithNoPhoneNumber.deal',
    [TICKET_TYPE_ID]: 'createActivityButtons.tooltip.whatsAppWithNoPhoneNumber.ticket'
  };
  return objectTypeKeys[objectTypeId];
};
const getWANumber = (fetchWANumber, objectTypeId) => {
  if (objectTypeId === CONTACT_TYPE_ID) {
    return fetchWANumber && fetchWANumber.data && fetchWANumber.data.crmObject && fetchWANumber.data.crmObject.defaultProperties && fetchWANumber.data.crmObject.defaultProperties.hs_whatsapp_phone_number && fetchWANumber.data.crmObject.defaultProperties.hs_whatsapp_phone_number.value;
  } else {
    const allAssociations = fetchWANumber && fetchWANumber.data && fetchWANumber.data.crmObject && fetchWANumber.data.crmObject.allAssociations;
    if (allAssociations) {
      for (const association of allAssociations) {
        const edges = association.associatedObjects && association.associatedObjects.edges;
        if (edges) {
          for (const edge of edges) {
            const waNumber = edge.node && edge.node.properties && edge.node.properties[0] && edge.node.properties[0].value;
            if (waNumber) {
              // returning the first WA number to indicate at least one contact has a WA number
              return waNumber;
            }
          }
        }
      }
    }
    return null;
  }
};
export const useWAButtonState = ({
  objectTypeId,
  objectId,
  currentUserCanCommunicate
}) => {
  const fetchWANumber = useFetchWANumber({
    objectId,
    objectTypeId
  });
  const waNumber = useMemo(() => getWANumber(fetchWANumber, objectTypeId), [fetchWANumber, objectTypeId]);
  const hasMessagingAccess = useHasScope('messaging-access');
  const hasMessagingTrusted = useHasScope('messaging-trusted');
  const hasConversationAccess = useHasScope('conversations-access');

  // Do scope and object type checks first that don't require a network request

  if (isCustomObject(objectTypeId)) {
    return {
      isDisabled: true,
      tooltipMessage: 'createActivityButtons.tooltip.whatsAppCustomObject'
    };
  }
  if (!currentUserCanCommunicate) {
    return {
      isDisabled: true,
      tooltipMessage: 'createActivityButtons.tooltip.disabled'
    };
  }
  if (!hasMessagingAccess) {
    return {
      isDisabled: true,
      tooltipMessage: 'createActivityButtons.tooltip.whatsAppNoPermission'
    };
  }
  if (!hasConversationAccess) {
    return {
      isDisabled: true,
      tooltipMessage: 'createActivityButtons.tooltip.whatsAppNoConversationAccess'
    };
  }
  if (hasMessagingAccess && !hasMessagingTrusted) {
    return {
      isDisabled: true,
      tooltipMessage: 'createActivityButtons.tooltip.whatsAppAccessRevoked'
    };
  }

  // Return that the network request is loading or if there is no WA number

  if (fetchWANumber.loading) {
    return {
      isLoading: true
    };
  }
  if (!waNumber) {
    return {
      isDisabled: true,
      tooltipMessage: getWAMissingNumberKey(objectTypeId)
    };
  }
  return {
    isDisabled: false
  };
};